import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "SearchBox" })
export default class SearchBox extends Vue {
    public categories: [] = [];
    public categorySlug: string = null;
    public searchText: string = null;
    public localizer: any = Localizer;

    @Prop() readonly historyCategory: string;
    @Prop() readonly historyText: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        const response = (await Axios.post(this.routes.Catalogue_GetCategories)).data;

        this.categories = response;

        if (this.historyCategory && this.historyCategory !== '') {
            this.categorySlug = this.historyCategory;
        }

        if (this.historyText && this.historyText !== '') {
            this.searchText = this.historyText;
        }
    }

    public setSearch() {
        if (this.searchText && this.searchText !== '') {
            let url = this.routes.Catalogue_ProductSearch + "?search=" + this.searchText;

            if (this.categorySlug && this.categorySlug !== '') {
                url += "&categorySlug=" + this.categorySlug;
            }

            GTagHelper.sendEvent("view_search_results", { search_term: this.searchText });

            window.location.href = url;
        } else if (this.categorySlug && this.categorySlug !== '') {
            GTagHelper.sendEvent("view_search_results", { search_category: this.categorySlug });

            window.location.href = this.routes.Catalogue_CategoryList + "/" + this.categorySlug;
        }
    }
};